import * as fromActions from '../actions/fx-rate.action';

export interface FxRateState {
  countryTreeData: any;
  currencyTreeData: any;
  reports: any;
}

export const initialState = <FxRateState> {
  currencyTreeData : {},
  countryTreeData : {},
  reports : {},
};

export function fxRateReducer(state: FxRateState = initialState, action: fromActions.fxRateActions ) {
  switch (action.type) {
    case fromActions.GET_COUNTRIES_TREE_DATA_SUCCESS: {
      const countryTreeDataAction = (action as fromActions.GetCountriesTreeDataSuccessAction);
      const data = state.countryTreeData;
      data[countryTreeDataAction.reportId+countryTreeDataAction.currencyType] = countryTreeDataAction.payload;
      return {
        ...state,
        countryTreeData: data
      };
    }
    case fromActions.GET_CURRENCIES_TREE_DATA_SUCCESS: {
      const currencyTreeDataAction = (action as fromActions.GetCurrenciesTreeDataSuccessAction);
      const data = state.currencyTreeData;
      data[currencyTreeDataAction.reportId+currencyTreeDataAction.currencyType] = currencyTreeDataAction.payload;
      return {
        ...state,
        currencyTreeData: data
      };
    }
    case fromActions.GET_FX_RATE_REPORT_SUCCESS: {
      const fxRateReportSuccessAction = (action as fromActions.GetFxRateReportSuccessAction);
      const data = state.reports;
      data[fxRateReportSuccessAction.reportId] = fxRateReportSuccessAction.payload;
      return {
        ...state,
        reports: data
      };
    }
    case fromActions.CLEAR_FX_RATE_REPORT_DATA: {
      const clearFxRateReportAction = (action as fromActions.ClearFxRateReportAction);
      const data = state.reports;
      delete data[clearFxRateReportAction.reportId];``
      return {
        ...state,
        reports: data
      };
    }
  }
  return state;
}


